
import * as util from 'util'

import * as big from '../big'
import * as int64 from '../int64'
import * as uuid from '../uuid'

import * as fbe from '../fbe'
import * as core from '../core'
import * as config from '../config'
import * as history from '../history'
import * as client from '../client'
import * as feed from '../feed'
import * as storage from '../storage'
import * as exposed from '../exposed'
import * as execution from '../execution'
import * as backup from '../backup'
import * as inner from '../inner'
import * as trade from '../trade'
import * as security from '../security'
import * as document from '../document'

const Big = big.Big // eslint-disable-line
const Int64 = int64.Int64 // eslint-disable-line
const UInt64 = int64.UInt64 // eslint-disable-line
const UUID = uuid.UUID // eslint-disable-line
import {ConfigUpdateRequest} from './ConfigUpdateRequest';
import {FieldModelConfigUpdateRequest} from './ConfigUpdateRequest';
import {FirewallRuleCreateResponse} from './FirewallRuleCreateResponse';
import {FirewallActionType} from '../core/FirewallActionType';
import {FieldModelFirewallActionType} from '../core/FirewallActionType';
import {IPv4Range} from '../core/IPv4Range';
import {FieldModelIPv4Range} from '../core/IPv4Range';

/**
 * FirewallRuleCreateRequest struct
 */
class FirewallRuleCreateRequest extends ConfigUpdateRequest {
  /**
   * Initialize struct
   * @param {!ConfigUpdateRequest=} parent
   * @param {number=} sortOrder
   * @param {!string=} name
   * @param {!string=} description
   * @param {!FirewallActionType=} firewallActionType
   * @param {!IPv4Range=} iPv4Range
   * @constructor
   */
  constructor (parent = new ConfigUpdateRequest(), sortOrder = null, name = '', description = '', firewallActionType = new FirewallActionType(), iPv4Range = new IPv4Range()) {
    super()
    super.copy(parent)
    this.SortOrder = sortOrder
    this.Name = name
    this.Description = description
    this.FirewallActionType = firewallActionType
    this.IPv4Range = iPv4Range
  }

  /**
   * Copy struct (shallow copy)
   * @this {!FirewallRuleCreateRequest}
   * @param {!FirewallRuleCreateRequest} other Other struct
   * @returns {!FirewallRuleCreateRequest} This struct
   */
  copy (other) {
    super.copy(other)
    if (other.SortOrder != null) {
      this.SortOrder = other.SortOrder
    } else {
      this.SortOrder = null
    }
    if (other.Name != null) {
      this.Name = other.Name
    } else {
      this.Name = null
    }
    if (other.Description != null) {
      this.Description = other.Description
    } else {
      this.Description = null
    }
    if (other.FirewallActionType != null) {
      this.FirewallActionType = FirewallActionType.fromObject(other.FirewallActionType)
    } else {
      this.FirewallActionType = null
    }
    if (other.IPv4Range != null) {
      this.IPv4Range = IPv4Range.fromObject(other.IPv4Range)
    } else {
      this.IPv4Range = null
    }
    return this
  }

  /**
   * Clone struct (deep clone)
   * @this {!FirewallRuleCreateRequest}
   * @returns {!FirewallRuleCreateRequest} Cloned struct
   */
  clone () {
    // Serialize the struct to the FBE stream
    let writer = new FirewallRuleCreateRequestModel(new fbe.WriteBuffer())
    writer.serialize(this)

    // Deserialize the struct from the FBE stream
    let reader = new FirewallRuleCreateRequestModel(new fbe.ReadBuffer())
    reader.attachBuffer(writer.buffer)
    return reader.deserialize().value
  }

  /**
   * Is this struct equal to other one?
   * @this {!FirewallRuleCreateRequest}
   * @param {!FirewallRuleCreateRequest} other Other struct
   * @returns {boolean} Equal result
   */
  eq (other) {
    if (!(other instanceof FirewallRuleCreateRequest)) {
      throw new TypeError('Instance of FirewallRuleCreateRequest is required!')
    }
    // noinspection RedundantIfStatementJS
    if (!super.eq(other)) {
      return false
    }
    return true
  }

  /**
   * Convert struct to JSON
   * @this {!FirewallRuleCreateRequest}
   * @returns {!object} Struct value for JSON
   */
  toJSON () {
    let parent = super.toJSON()
    let current = {
      SortOrder: ((this.SortOrder != null) ? this.SortOrder : null),
      Name: ((this.Name != null) ? this.Name : null),
      Description: ((this.Description != null) ? this.Description : null),
      FirewallActionType: ((this.FirewallActionType != null) ? this.FirewallActionType : null),
      IPv4Range: ((this.IPv4Range != null) ? this.IPv4Range : null)
    }
    return { ...parent, ...current }
  }

  /**
   * Convert JSON to struct
   * @param {!string} json JSON string
   * @returns {!object} Struct value for JSON
   */
  static fromJSON (json) {
    return FirewallRuleCreateRequest.fromObject(JSON.parse(json))
  }

  /**
   * Create struct from object value
   * @param {!FirewallRuleCreateRequest} other Object value
   * @returns {!FirewallRuleCreateRequest} Created struct
   */
  static fromObject (other) {
    return new FirewallRuleCreateRequest().copy(other)
  }

  /**
   * Get the FBE type
   * @this {!FirewallRuleCreateRequest}
   * @returns {!number} FBE type
   */
  get fbeType () {
    return FirewallRuleCreateRequest.fbeType
  }

  /**
   * Get the FBE type (static)
   * @this {!FirewallRuleCreateRequest}
   * @returns {!number} FBE type
   */
  static get fbeType () {
    return 6547
  }
}

export { FirewallRuleCreateRequest };

/**
 * Fast Binary Encoding FirewallRuleCreateRequest field model
 */
class FieldModelFirewallRuleCreateRequest extends fbe.FieldModel {
  /**
   * Initialize field model with the given buffer and offset
   * @param {!fbe.ReadBuffer|!fbe.WriteBuffer} buffer Buffer
   * @param {!number} offset Offset
   * @constructor
   */
  constructor (buffer, offset) {
    super(buffer, offset)
    this._parent = new FieldModelConfigUpdateRequest(buffer, 4 + 4)
    this.SortOrder = new fbe.FieldModelOptional(new fbe.FieldModelUInt32(buffer, this._parent.fbeOffset + this._parent.fbeBody - 4 - 4), buffer, this._parent.fbeOffset + this._parent.fbeBody - 4 - 4)
    this.Name = new fbe.FieldModelString(buffer, this.SortOrder.fbeOffset + this.SortOrder.fbeSize)
    this.Description = new fbe.FieldModelString(buffer, this.Name.fbeOffset + this.Name.fbeSize)
    this.FirewallActionType = new FieldModelFirewallActionType(buffer, this.Description.fbeOffset + this.Description.fbeSize)
    this.IPv4Range = new FieldModelIPv4Range(buffer, this.FirewallActionType.fbeOffset + this.FirewallActionType.fbeSize)
  }

  /**
   * Get the ConfigUpdateRequest field model
   * @this {!FieldModelFirewallRuleCreateRequest}
   * @returns {!FieldModelConfigUpdateRequest} ConfigUpdateRequest field model
   */
  get parent () {
    return this._parent
  }

  /**
   * Get the field size
   * @this {!FieldModelFirewallRuleCreateRequest}
   * @returns {!number} Field size
   */
  get fbeSize () {
    return 4
  }

  /**
   * Get the field body size
   * @this {!FieldModelFirewallRuleCreateRequest}
   * @returns {!number} Field body size
   */
  get fbeBody () {
    return 4 + 4 + this.parent.fbeBody - 4 - 4 + this.SortOrder.fbeSize + this.Name.fbeSize + this.Description.fbeSize + this.FirewallActionType.fbeSize + this.IPv4Range.fbeSize
  }

  /**
   * Get the field extra size
   * @this {!FieldModelFirewallRuleCreateRequest}
   * @returns {!number} Field extra size
   */
  get fbeExtra () {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4) > this._buffer.size)) {
      return 0
    }

    this._buffer.shift(fbeStructOffset)

    let fbeResult = this.fbeBody + this.parent.fbeExtra + this.SortOrder.fbeExtra + this.Name.fbeExtra + this.Description.fbeExtra + this.FirewallActionType.fbeExtra + this.IPv4Range.fbeExtra

    this._buffer.unshift(fbeStructOffset)

    return fbeResult
  }

  /**
   * Get the field type
   * @this {!FieldModelFirewallRuleCreateRequest}
   * @returns {!number} Field type
   */
  get fbeType () {
    return FieldModelFirewallRuleCreateRequest.fbeType
  }

  /**
   * Get the field type (static)
   * @this {!FieldModelFirewallRuleCreateRequest}
   * @returns {!number} Field type
   */
  static get fbeType () {
    return 6547
  }

  /**
   * Check if the struct value is valid
   * @this {!FieldModelFirewallRuleCreateRequest}
   * @param {!boolean} fbeVerifyType Verify model type flag, defaults is true
   * @returns {!boolean} Field model valid state
   */
  verify (fbeVerifyType = true) {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return true
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4 + 4) > this._buffer.size)) {
      return false
    }

    let fbeStructSize = this.readUInt32(fbeStructOffset)
    if (fbeStructSize < (4 + 4)) {
      return false
    }

    let fbeStructType = this.readUInt32(fbeStructOffset + 4)
    if (fbeVerifyType && (fbeStructType !== this.fbeType)) {
      return false
    }

    this._buffer.shift(fbeStructOffset)
    let fbeResult = this.verifyFields(fbeStructSize)
    this._buffer.unshift(fbeStructOffset)
    return fbeResult
  }

  /**
   * Check if the struct fields are valid
   * @this {!FieldModelFirewallRuleCreateRequest}
   * @param {!number} fbeStructSize FBE struct size
   * @returns {!boolean} Field model valid state
   */
  verifyFields (fbeStructSize) {
    let fbeCurrentSize = 4 + 4

    if ((fbeCurrentSize + this.parent.fbeBody - 4 - 4) > fbeStructSize) {
      return true
    }
    if (!this.parent.verifyFields(fbeStructSize)) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.parent.fbeBody - 4 - 4

    if ((fbeCurrentSize + this.SortOrder.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.SortOrder.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.SortOrder.fbeSize

    if ((fbeCurrentSize + this.Name.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.Name.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.Name.fbeSize

    if ((fbeCurrentSize + this.Description.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.Description.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.Description.fbeSize

    if ((fbeCurrentSize + this.FirewallActionType.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.FirewallActionType.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.FirewallActionType.fbeSize

    if ((fbeCurrentSize + this.IPv4Range.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.IPv4Range.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.IPv4Range.fbeSize

    return true
  }

  /**
   * Get the struct value (begin phase)
   * @this {!FieldModelFirewallRuleCreateRequest}
   * @returns {!number} Field model begin offset
   */
  getBegin () {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    console.assert((fbeStructOffset > 0) && ((this._buffer.offset + fbeStructOffset + 4 + 4) <= this._buffer.size), 'Model is broken!')
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4 + 4) > this._buffer.size)) {
      return 0
    }

    let fbeStructSize = this.readUInt32(fbeStructOffset)
    console.assert((fbeStructSize >= (4 + 4)), 'Model is broken!')
    if (fbeStructSize < (4 + 4)) {
      return 0
    }

    this._buffer.shift(fbeStructOffset)
    return fbeStructOffset
  }

  /**
   * Get the struct value (end phase)
   * @this {!FieldModelFirewallRuleCreateRequest}
   * @param {!number} fbeBegin Field model begin offset
   */
  getEnd (fbeBegin) {
    this._buffer.unshift(fbeBegin)
  }

  /**
   * Get the struct value
   * @this {!FieldModelFirewallRuleCreateRequest}
   * @param {!FirewallRuleCreateRequest} fbeValue Default value, defaults is new FirewallRuleCreateRequest()
   * @returns {!FirewallRuleCreateRequest} FirewallRuleCreateRequest value
   */
  get (fbeValue = new FirewallRuleCreateRequest()) {
    let fbeBegin = this.getBegin()
    if (fbeBegin === 0) {
      return fbeValue
    }

    let fbeStructSize = this.readUInt32(0)
    this.getFields(fbeValue, fbeStructSize)
    this.getEnd(fbeBegin)
    return fbeValue
  }

  /**
   * Get the struct fields values
   * @this {!FieldModelFirewallRuleCreateRequest}
   * @param {!FirewallRuleCreateRequest} fbeValue FirewallRuleCreateRequest value
   * @param {!number} fbeStructSize Struct size
   */
  getFields (fbeValue, fbeStructSize) {
    let fbeCurrentSize = 4 + 4

    if ((fbeCurrentSize + this.parent.fbeBody - 4 - 4) <= fbeStructSize) {
      this.parent.getFields(fbeValue, fbeStructSize)
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.parent.fbeBody - 4 - 4

    if ((fbeCurrentSize + this.SortOrder.fbeSize) <= fbeStructSize) {
      fbeValue.SortOrder = this.SortOrder.get()
    } else {
      fbeValue.SortOrder = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.SortOrder.fbeSize

    if ((fbeCurrentSize + this.Name.fbeSize) <= fbeStructSize) {
      fbeValue.Name = this.Name.get()
    } else {
      fbeValue.Name = ''
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.Name.fbeSize

    if ((fbeCurrentSize + this.Description.fbeSize) <= fbeStructSize) {
      fbeValue.Description = this.Description.get()
    } else {
      fbeValue.Description = ''
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.Description.fbeSize

    if ((fbeCurrentSize + this.FirewallActionType.fbeSize) <= fbeStructSize) {
      fbeValue.FirewallActionType = this.FirewallActionType.get()
    } else {
      fbeValue.FirewallActionType = new FirewallActionType()
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.FirewallActionType.fbeSize

    if ((fbeCurrentSize + this.IPv4Range.fbeSize) <= fbeStructSize) {
      fbeValue.IPv4Range = this.IPv4Range.get()
    } else {
      fbeValue.IPv4Range = new IPv4Range()
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.IPv4Range.fbeSize
  }

  /**
   * Set the struct value (begin phase)
   * @this {!FieldModelFirewallRuleCreateRequest}
   * @returns {!number} Field model begin offset
   */
  setBegin () {
    console.assert(((this._buffer.offset + this.fbeOffset + this.fbeSize) <= this._buffer.size), 'Model is broken!')
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructSize = this.fbeBody
    let fbeStructOffset = this._buffer.allocate(fbeStructSize) - this._buffer.offset
    console.assert((fbeStructOffset > 0) && ((this._buffer.offset + fbeStructOffset + fbeStructSize) <= this._buffer.size), 'Model is broken!')
    if ((fbeStructOffset <= 0) || ((this._buffer.offset + fbeStructOffset + fbeStructSize) > this._buffer.size)) {
      return 0
    }

    this.writeUInt32(this.fbeOffset, fbeStructOffset)
    this.writeUInt32(fbeStructOffset, fbeStructSize)
    this.writeUInt32(fbeStructOffset + 4, this.fbeType)

    this._buffer.shift(fbeStructOffset)
    return fbeStructOffset
  }

  /**
   * Set the struct value (end phase)
   * @this {!FieldModelFirewallRuleCreateRequest}
   * @param {!number} fbeBegin Field model begin offset
   */
  setEnd (fbeBegin) {
    this._buffer.unshift(fbeBegin)
  }

  /**
   * Set the struct value
   * @this {!FieldModelFirewallRuleCreateRequest}
   * @param {!FirewallRuleCreateRequest} fbeValue FirewallRuleCreateRequest value
   */
  set (fbeValue) {
    let fbeBegin = this.setBegin()
    if (fbeBegin === 0) {
      return
    }

    this.setFields(fbeValue)
    this.setEnd(fbeBegin)
  }

  /**
   * Set the struct fields values
   * @this {!FieldModelFirewallRuleCreateRequest}
   * @param {FirewallRuleCreateRequest} fbeValue FirewallRuleCreateRequest value
   */
  setFields (fbeValue) {
    this.parent.setFields(fbeValue)
    this.SortOrder.set(fbeValue.SortOrder)
    this.Name.set(fbeValue.Name)
    this.Description.set(fbeValue.Description)
    this.FirewallActionType.set(fbeValue.FirewallActionType)
    this.IPv4Range.set(fbeValue.IPv4Range)
  }
}

export { FieldModelFirewallRuleCreateRequest };

/**
 * Fast Binary Encoding FirewallRuleCreateRequest model
 */
class FirewallRuleCreateRequestModel extends fbe.Model {
  /**
   * Initialize model with the given buffer
   * @param {!fbe.ReadBuffer|!fbe.WriteBuffer} buffer Read/Write buffer, defaults is new fbe.WriteBuffer()
   * @constructor
   */
  constructor (buffer = new fbe.WriteBuffer()) {
    super(buffer)
    this._model = new FieldModelFirewallRuleCreateRequest(this.buffer, 4)
  }

  /**
   * Get the FirewallRuleCreateRequest model
   * @this {!FirewallRuleCreateRequestModel}
   * @returns {!FieldModelFirewallRuleCreateRequest} model FirewallRuleCreateRequest model
   */
  get model () {
    return this._model
  }

  /**
   * Get the model size
   * @this {!FirewallRuleCreateRequestModel}
   * @returns {!number} Model size
   */
  get fbeSize () {
    return this.model.fbeSize + this.model.fbeExtra
  }

  /**
   * Get the model type
   * @this {!FirewallRuleCreateRequestModel}
   * @returns {!number} Model type
   */
  get fbeType () {
    return FirewallRuleCreateRequestModel.fbeType
  }

  /**
   * Get the model type (static)
   * @this {!FirewallRuleCreateRequestModel}
   * @returns {!number} Model type
   */
  static get fbeType () {
    return FieldModelFirewallRuleCreateRequest.fbeType
  }

  /**
   * Check if the struct value is valid
   * @this {!FirewallRuleCreateRequestModel}
   * @returns {!boolean} Model valid state
   */
  verify () {
    if ((this.buffer.offset + this.model.fbeOffset - 4) > this.buffer.size) {
      return false
    }

    let fbeFullSize = this.readUInt32(this.model.fbeOffset - 4)
    if (fbeFullSize < this.model.fbeSize) {
      return false
    }

    return this.model.verify()
  }

  /**
   * Create a new model (begin phase)
   * @this {!FirewallRuleCreateRequestModel}
   * @returns {!number} Model begin offset
   */
  createBegin () {
    return this.buffer.allocate(4 + this.model.fbeSize)
  }

  /**
   * Create a new model (end phase)
   * @this {!FirewallRuleCreateRequestModel}
   * @param {!number} fbeBegin Model begin offset
   */
  createEnd (fbeBegin) {
    let fbeEnd = this.buffer.size
    let fbeFullSize = fbeEnd - fbeBegin
    this.writeUInt32(this.model.fbeOffset - 4, fbeFullSize)
    return fbeFullSize
  }

  /**
   * Serialize the struct value
   * @this {!FirewallRuleCreateRequestModel}
   * @param {!FirewallRuleCreateRequest} value FirewallRuleCreateRequest value
   * @return {!number} Model begin offset
   */
  serialize (value) {
    let fbeBegin = this.createBegin()
    this.model.set(value)
    return this.createEnd(fbeBegin)
  }

  /**
   * Deserialize the struct value
   * @this {!FirewallRuleCreateRequestModel}
   * @param {!FirewallRuleCreateRequest} value FirewallRuleCreateRequest value, defaults is new FirewallRuleCreateRequest()
   * @return {!object} Deserialized FirewallRuleCreateRequest value and its size
   */
  deserialize (value = new FirewallRuleCreateRequest()) {
    if ((this.buffer.offset + this.model.fbeOffset - 4) > this.buffer.size) {
      return { value: new FirewallRuleCreateRequest(), size: 0 }
    }

    let fbeFullSize = this.readUInt32(this.model.fbeOffset - 4)
    console.assert((fbeFullSize >= this.model.fbeSize), 'Model is broken!')
    if (fbeFullSize < this.model.fbeSize) {
      return { value: new FirewallRuleCreateRequest(), size: 0 }
    }

    this.model.get(value)
    return { value: value, size: fbeFullSize }
  }

  /**
   * Move to the next struct value
   * @this {!FirewallRuleCreateRequestModel}
   * @param {!number} prev Previous FirewallRuleCreateRequest model size
   */
  next (prev) {
    this.model.fbeShift(prev)
  }
}

export { FirewallRuleCreateRequestModel };
FirewallRuleCreateRequest.__has_response = true;
FirewallRuleCreateRequest.__response_class = FirewallRuleCreateResponse;
